// Sport Energy Træningsberegner — motor + side-UI (Fase 7.32.1)
//
// FASE 7.32.1 (jun 2026): Gel-dæknings-note. Når den valgte gel-størrelse
// rammer kulhydrat-MÅLET dårligt (fx 2 × 40 = 80 g, i underkanten på 1½ t
// tempo), foreslår en rolig note den størrelse der lander i båndet med
// samme-eller-færre geler (her: 2 × 45 = 90 g). Det er her 45 g-gelen får
// mening. Selve gel-TIDERNE er bevidst uændrede mellem 40 g og 45 g når
// antallet er ens — det er fagligt korrekt (n geler over T fordeles ens
// uanset størrelse); 45 g'ens værdi er at ramme totalen, ikke at flytte ur.
//
// FASE 7.32.0 (jun 2026): 45 g tilføjet til gel-slideren (Victus-gels på
// lager). Rammer mellemlange tempopas bedre: 1½ t tempo har et mål på
// ~90 g, hvor 2 × 40 = 80 g var i underkanten — 2 × 45 = 90 g lander spot
// on. Slideren er datadrevet (SNAP.gel.steps), så tick, track og marker
// følger automatisk.
//
// FASE 7.31.0 (jun 2026): Gel-tider trukket væk fra enderne. Slice-midt-
// modellen lagde første/sidste gel for tæt på start/slut (1 t / 2 geler →
// 0:15, 0:45, hvor den sidste lå for sent). Nu fordeles gelerne jævnt over
// et VINDUE der starter ~20 min inde (15 på tom mave) og slutter 15–20 min
// før mål — så 1 t / 2 geler bliver 0:20 og 0:40. Minimums-mellemrum (15 min)
// på korte pas, så de ikke klumper.
//
// FASE 7.30.0 (jun 2026): Gel-trin som TIDSLISTE. Under "Sådan gør du
// undervejs" vises hvert gel-tidspunkt nu som sin egen række (klokkeslæt
// i mærke-kolonnen + "1. gel", "2. gel"...) i stedet for én rytme-linje.
// Nemmere at handle på. Fordelingen er fortsat jævn (sidste gel ~20 min
// før slut — fagligt stærkest på pas der køres ud; sent-indtaget kulhydrat
// når stadig at virke). For >5 geler falder vi tilbage til rytme-linjen,
// så listen ikke bliver støj.
//
// FASE 7.29.0 (jun 2026): Gel-fordeling rettet + sprog. To ting:
//  • Gelerne fordeles nu JÆVNT over hele passet (slice-midtpunkt: gel k ved
//    T/n × (k+0,5)), så kulhydratet kommer i stabilt tempo. Før klumpede de:
//    2 t / 3 geler sagde "start 0:30, hver 30" → 80 g i time 1, 40 g i time 2.
//    Nu: "start 0:20, hver 40" → 0:20, 1:00, 1:40, jævnt fordelt.
//  • "Bidon/Bidoner" → "Flaske/Flasker" for cykel (bidon var for niche).
//
// FASE 7.28.0 (jun 2026): "Sådan gør du undervejs"-folden får et mint
// rute-ikon og en højre-pegende pil (roterer ned ved åbning) — samme
// disclosure-mønster som "Personlige indstillinger". Halve tal (½) pakkes
// nu i en lille styled span (tp-frac), så de sidder neat ved heltallet i
// stedet for at crowde ("1½×" så rodet ud). Se page.traening for CSS.
//
// FASE 7.27.1 (jun 2026): App-header-fix. I standalone blev Shopify-headeren
// stadig vist, fordi Ella/Halo pakker header-gruppe + main + footer i én
// fælles <div class="body-content-wrapper"> — så den gamle "skjul body's
// børn før main" ramte intet. hideShopifyChrome targeter nu temaets faktiske
// gruppe-klasser (.shopify-section-group-header-group/-footer-group,
// .announcement-bar, header.header) PLUS en generisk søskende-fejning på
// forgrenings-niveauet. Testet mod den rigtige live-DOM.
//
// FASE 7.27.0 (jun 2026): Standard 1½ time (åbner med synlig brændstofplan);
// dybere, lagdelt iPhone-skygge i page.traening (svæver mere).
//
// FASE 7.26.0 (jun 2026): Standard Easy; defaults og copy-oprydning;
// "Personlige indstillinger"-pil peger til højre (lukket) og roterer ned.
//
// FASE 7.25.0 (jun 2026): Microsoft Clarity-tracking. Samme mønster som
// guiden (seg_track via window.clarity, loadet på tema-niveau). Events:
// traening_opened (page-view m. enheds-tilstand), _sport, _duration,
// _traintype, _form, _personal_setting (stomach/gut/sweat), _plan_expanded,
// _qr, _install (prompt+choice) og _result (DEBOUNCED ~1,2 s — det færdige
// pas med beregnet kulhydrat/væske, ikke støj på hver slider-justering).
// Tag-præfiks 'tr_'. Fejler stille hvis Clarity ikke er indlæst.
//
// FASE 7.24.2 (jun 2026): Anbefalings-systemet PARKERET. Den orange
// "Anbefalet: X g"-prik/-note på pulver- og gel-sliderne er slået fra,
// mens den gentænkes offline. Den var for restriktiv (man kan fint drikke
// energipulver på en tempotime) og inkonsistent på "begge". recommendedSize
// returnerer null, hvilket fjerner hele anbefalings-UI'et rent — sliderne
// virker som plain sliders. Logikken er bevaret i koden, klar til revival.
//
// FASE 7.24.1 (jun 2026): App-hoved. I standalone skjules Shopify-temaets
// header/banner/footer nu også strukturelt i JS (hideShopifyChrome) — de
// gamle CSS-klasse-regler ramte ikke Ella/Halo-temaets header. Den
// mørkegrønne logo-bjælke (tp-app-top) er sat tilbage som appens eget
// hoved øverst; produktkategori-footeren bliver i bunden. Se page.traening.
//
// FASE 7.24.0 (jun 2026): App-look. Desktop-showcasens telefon-mockup
// havde en "Skærmbillede kommer her"-placeholder — fjernet (der ligger
// nu et rigtigt billede). Produktkategori-footer tilføjet i app-tilstand.
//
// FASE 7.23.0 (jun 2026): Cykel-tilpasning. Sporten påvirkede før kun
// resultatets label — nu former den hele svaret:
//  • Varigheds-hurtigvalg pr. sport: løb 45 min–3 t, cykel 1–5 t
//    (få vælger 45 min cykeltræning; flere kører 4–5 t). JS-renderet.
//  • Cykel-carb-bånd løftet i den øvre ende på mellem/lange pas: på
//    cyklen er det praktisk muligt at spise/drikke mere, og GI-tolerancen
//    er højere end på løb (litteratur: cyklen giver bedst mulighed for
//    højt kulhydrat/væske-indtag; ~40–60 g/t i Z2, ~90 g/t på hårde ture
//    >2,5 t). Korte/lette pas holdes tæt på løb.
//  • Pulver-koncentrations-anbefaling: løb 30 g (mavehensyn), cykel 40 g
//    (bidonen drikkes roligt fra holderen — ingen grund til lav koncentr.).
//  • Sprog: bidon/holder i stedet for vest/blære/softflaske; "bare kør"
//    i stedet for "bare løb". Samlet i sportTerms() — ét sted, ikke spredt.
//
// FASE 7.22.0 (jun 2026): Gel-timing. Intervallet fordeler nu gelerne
// jævnt over hele passet (vindue/n, ikke n−1) — 2 geler på 1 t bliver
// 0:20 og 0:40. Én gel placeres ca. midtvejs (1 t 30 → 0:45) i stedet
// for fast 20 min. Anbefalet gel-/pulverstørrelse vises nu også på tempo,
// og pulver-anbefalingen nævner at tage gels ved siden af. Prikken på
// sliderne flyttet til selve sporet (thumb-geometri) så den rammer spot on.
//
// FASE 7.21.3 (jun 2026): Personlige indstillinger — knapperne (Svedrate,
// mave-tilstand, mavetolerance) bruger nu den glidende se-seg-pille som
// Sport-knappen, i stedet for de gamle runde radio-piller. Hver række får
// .se-seg + inline grid; --seg-i sættes fra tilstanden (re-render ved klik).
// Ny setSweat-handler glider svedrate-pillen (den re-renderer ikke folden).
//
// FASE 7.21.0 (jun 2026): Install-kortet i mobil-browseren er nu en
// app-header — en mørkegrøn logo-bjælke (samme look som standalone-
// app-toppen) med en diskret install-linje under. Logo-bjælken er fast
// i markupen; JS skriver kun install-teksten i #tp-install-body, så
// siden ser app-agtig ud allerede før man henter den ned.
//
// FASE 7.20.0 (jun 2026): Mobil dose-fliser. Tallet ("2×") og ordet
// ("Pulver"/"Flasker") sidder nu i hver sit span (.tp-dose-n / .tp-dose-w),
// så de stables rent på smalle skærme i stedet for at wrappe grimt midt
// i den fede linje. CSS skalerer tallet og ordet pr. skærmbredde.
//
// FASE 7.19.0 (jun 2026): Navn + app-illusion. Værktøjet hedder nu
// "Energiplan" (app-titel på hjemskærmen, manifest short_name).
// Showcase-overskriften "Din energiplan til dagens træning" — dropper
// "som en app" (vis, fortæl ikke). Ny Apple-stil "Hent app"-knap
// (sort pille, æble-ikon) ved siden af gratis-badge; på desktop fører
// den til QR-koden (scrollToQR, kort mint-glød) — vejen til mobilen.
// Folden "Personlige indstillinger" viser nu kun navnet (summary-linje
// fjernet — støj for dem der ikke bruger den).
//
// FASE 7.18.x: Sektions-baggrunde, sport-pille-grid, USP "Skræddersy".
// FASE 7.17.0: Desktop-showcase, toolbar fjernet.
// FASE 7.16.x: Anbefalet størrelse, type-specifik tekst, sprog.
// FASE 7.0–7.15: Pak-beregner, skæve varigheder, ikoner, switch, audit.
//
// Motoren computeWeek/computeSession/bucket/carbBand testes i node.
// Bevidste grænser (låst): ALDRIG kost, kalorier, vægt eller køn.

(function () {
  'use strict';

  function num(v) {
    if (typeof v === 'number') return v;
    if (typeof v !== 'string' || v.trim() === '') return NaN;
    return parseFloat(v.replace(',', '.'));
  }
  function round50(x) { return Math.round(x / 50) * 50; }

  var DAYS = ['Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag', 'Søndag'];

  function bucket(minutes) {
    if (minutes < 60) return 'under-1t';
    if (minutes <= 120) return '1-2t';
    if (minutes <= 240) return '2-4t';
    return 'over-4t';
  }

  // Spejler guidens getCarbTarget-bånd. Hverdagsnuance: korte
  // moderate pas får 'valgfrit' — vand rækker, energi løfter kvalitet.
  // FASE 7.4.0: tre reelle bånd (let/moderat/hård). BEVIDST AFVIGELSE
  // fra guidens getCarbTarget: guiden skelner kun let/ikke-let på de
  // fleste varigheder, men i beregneren står de tre intensitets-knapper
  // synlige samtidig — så hvis moderat og hård gav samme tal, ville det
  // læse som en fejl. Derfor får hård (Z4-Z5) et lille, fagligt-rimeligt
  // løft over moderat (Z3) på mellem/lange pas — et Z4-Z5-pas tømmer
  // glykogen hurtigere. På korte pas holdes de tæt (kulhydrat er
  // marginalt der uanset). Let-båndet matcher guiden 1:1.
  //
  // FASE 7.23.0: sport-parameter. Løb-tabellen er BASIS (uændret). På
  // cyklen er det praktisk muligt at indtage mere (bidonen drikkes
  // roligt fra holderen), og GI-tolerancen er højere end løbets — derfor
  // løftes cykel-båndene i den øvre ende på mellem/lange pas, mod den
  // veldokumenterede 90–120 g/t-ende på lange hårde ture. Korte og lette
  // pas holdes tæt på løb (kulhydrat er marginalt der uanset). Default
  // 'loeb', så motor-tests og guide-paritet ikke ændres.
  function carbBand(b, intensity, sport) {
    var loeb = baseCarbBand(b, intensity);
    if (sport !== 'cykel' || !loeb) return loeb;
    return cykelLift(b, intensity, loeb);
  }
  function baseCarbBand(b, intensity) {
    if (b === 'under-1t') {
      if (intensity === 'let') return null;
      if (intensity === 'moderat') return { gMin: 30, gMax: 60, optional: true };
      return { gMin: 60, gMax: 60 }; // hård
    }
    if (b === '1-2t') {
      if (intensity === 'let') return { gMin: 45, gMax: 60 };
      if (intensity === 'moderat') return { gMin: 60, gMax: 75 };
      return { gMin: 70, gMax: 85 }; // hård — et hak over moderat
    }
    if (b === '2-4t') {
      if (intensity === 'let') return { gMin: 60, gMax: 75 };
      if (intensity === 'moderat') return { gMin: 75, gMax: 90 };
      return { gMin: 85, gMax: 100 }; // hård
    }
    // over-4t
    if (intensity === 'let') return { gMin: 75, gMax: 90 };
    if (intensity === 'moderat') return { gMin: 85, gMax: 100 };
    return { gMin: 90, gMax: 120 }; // hård
  }
  // Cykel-løft oven på løb-basis. Bevarer optional-flag og evt. gut-felt.
  // Under 1 t: ingen ændring. Ellers et moderat løft i øvre ende (og en
  // smule i nedre på de lange hårde), så cyklen lander mod 90–120 g/t.
  function cykelLift(b, intensity, base) {
    var d = { under_1t: { let: [0,0], moderat: [0,0], haard: [0,0] },
              t1_2:     { let: [0,0], moderat: [5,5], haard: [5,5] },
              t2_4:     { let: [0,5], moderat: [5,5], haard: [5,10] },
              over4:    { let: [0,5], moderat: [5,10], haard: [10,0] } };
    var key = b === 'under-1t' ? 'under_1t' : b === '1-2t' ? 't1_2' : b === '2-4t' ? 't2_4' : 'over4';
    var dd = d[key][intensity] || [0,0];
    var out = { gMin: base.gMin + dd[0], gMax: base.gMax + dd[1] };
    if (base.optional) out.optional = true;
    return out;
  }

  // ── FASE 7.0.0: ét pas, fuldt svar ─────────────────
  // cfg: { minutes, intensity, sweatMlPerHour, sodiumMgPerL }
  // Natrium-formlen er race-kittets: fluid i liter × mg/L, rundet
  // til nærmeste 10 — så svedtest, race-kit og pak-beregner siger
  // det samme tal for den samme atlet.
  function computeSession(cfg) {
    cfg = cfg || {};
    var m = num(cfg.minutes);
    if (isNaN(m) || m < 15 || m > 600) {
      return { ok: false, error: 'Varigheden skal være mellem 15 minutter og 10 timer.' };
    }
    var sweat = num(cfg.sweatMlPerHour);
    if (isNaN(sweat) || sweat < 400 || sweat > 2500) {
      return { ok: false, error: 'Svedraten skal være mellem 400 og 2500 ml i timen.' };
    }
    var naPerL = num(cfg.sodiumMgPerL);
    if (isNaN(naPerL) || naPerL < 200 || naPerL > 2000) naPerL = 700;
    var intensity = cfg.intensity === 'let' || cfg.intensity === 'haard' ? cfg.intensity : 'moderat';
    var sport = cfg.sport === 'cykel' ? 'cykel' : 'loeb';
    var hours = m / 60;
    var band = carbBand(bucket(m), intensity, sport);
    // Hverdagsnuance (kun pak-beregneren): et let pas til og med
    // 75 min klarer sig med vand. Guidens 1-2t-bånd (45–60 g/t let)
    // er kalibreret til hele spændet — på den korte ende af det er
    // svaret softflaske med elektrolyt eller ingenting.
    if (intensity === 'let' && m <= 75) band = null;
    // FASE 7.6.0: mavetolerance-mål (90/120 g/t) overstyrer båndet
    // fuldstændigt — tarmtræning handler om mængde, ikke om passet.
    var gut = num(cfg.gutTarget);
    var gutActive = gut === 90 || gut === 120;
    // Standard sigter mod LAVE ende af båndet (mavevenligt, "start
    // lavt"-princippet) — ikke midtpunktet. Gut-mål overstyrer.
    var perHour;
    if (gutActive) { perHour = gut; band = { gMin: gut, gMax: gut, gut: true }; }
    else perHour = band ? band.gMin : 0;
    // FASE 7.14.0: næringsmængden følger varigheden.
    // Tærskel-reglen (rest under 20 forsvinder, 20–49 = halv, 50+ op)
    // gælder KUN resten OVER mindst én hel time — det er der "1 t 20 =
    // 1 flaske" giver mening. For et SUB-time-pas (under 60 min) er der
    // ingen hel time at runde rest fra, så vi skalerer til den faktiske
    // tid: 45 min = 0,75 t, ikke en floor til 0,5. Ellers undertælles
    // korte hårde pas (45 min hårdt blev før 30 g i stedet for ~45 g).
    var full = Math.floor(m / 60), rest = m % 60;
    var effHours;
    if (full === 0) {
      effHours = m / 60;                 // sub-time: faktisk tid
    } else if (rest >= 50) {
      effHours = full + 1;
    } else if (rest >= 20) {
      effHours = full + 0.5;
    } else {
      effHours = full;                   // rest under 20 min forsvinder
    }
    var carbsG = Math.round(perHour * effHours);
    // Væske: ~1 flaske (500 ml) i timen som standard. Det matcher
    // pakke-logikken (flasker = timer). Kun ved høj svedrate løftes
    // det — håndteres i UI'ets flaske-note, ikke her.
    var fluidMl = round50(500 * effHours);
    var sodiumMg = Math.round(fluidMl / 1000 * naPerL / 10) * 10;
    return {
      ok: true,
      minutes: m, intensity: intensity, sport: sport, band: band,
      carbsG: carbsG, fluidMl: fluidMl, sodiumMg: sodiumMg, perHour: perHour,
      waterOnly: !band,
      optional: !!(band && band.optional && !gutActive),
      gutActive: gutActive,
      recovery: m >= 90 || intensity === 'haard'
    };
  }

  // cfg: { sessions:[{day 0-6, minutes, intensity}], sweatMlPerHour, productCarbsG }
  function computeWeek(cfg) {
    cfg = cfg || {};
    var ss = cfg.sessions || [];
    if (!ss.length) return { ok: false, error: 'Tilføj mindst ét pas.' };
    var sweat = num(cfg.sweatMlPerHour);
    if (isNaN(sweat) || sweat < 400 || sweat > 2500) {
      return { ok: false, error: 'Svedraten skal være mellem 400 og 2500 ml i timen.' };
    }
    var prodCarbs = num(cfg.productCarbsG);
    var hasProduct = !isNaN(prodCarbs) && prodCarbs >= 5;

    var out = [], totMin = 0, totC = 0, totU = 0;
    for (var i = 0; i < ss.length; i++) {
      var m = num(ss[i].minutes);
      if (isNaN(m) || m < 15 || m > 600) {
        return { ok: false, error: 'Pas ' + (i + 1) + ': varigheden skal være mellem 15 minutter og 10 timer.' };
      }
      var day = parseInt(ss[i].day, 10);
      if (isNaN(day) || day < 0 || day > 6) day = 0;
      var intensity = ss[i].intensity === 'let' || ss[i].intensity === 'haard' ? ss[i].intensity : 'moderat';
      var sport = (ss[i].sport || cfg.sport) === 'cykel' ? 'cykel' : 'loeb';
      var hours = m / 60;
      var band = carbBand(bucket(m), intensity, sport);
      var carbsG = band ? Math.round((band.gMin + band.gMax) / 2 * hours) : 0;
      var fluidMl = round50(sweat * 0.75 * hours);
      var units = hasProduct && carbsG ? Math.ceil(carbsG / prodCarbs * 2) / 2 : null;
      var recovery = m >= 90 || intensity === 'haard';
      totMin += m; totC += carbsG; if (units) totU += units;
      out.push({
        day: day, dayName: DAYS[day], minutes: m, intensity: intensity,
        band: band, carbsG: carbsG, fluidMl: fluidMl,
        units: units, recovery: recovery,
        waterOnly: !band, optional: !!(band && band.optional)
      });
    }
    out.sort(function (a, b) { return a.day - b.day || b.minutes - a.minutes; });
    return {
      ok: true, sessions: out,
      totals: {
        count: ss.length,
        hours: Math.round(totMin / 60 * 10) / 10,
        carbsG: totC,
        units: hasProduct ? Math.ceil(totU) : null,
        unitsMonth: hasProduct ? Math.ceil(totU * 4.3) : null
      }
    };
  }

  window.SportEnergyTraining = {
    computeWeek: computeWeek,
    computeSession: computeSession,
    bucket: bucket,
    carbBand: carbBand
  };

  // ── Side-UI (FASE 7.0.0) ───────────────────────────
  if (typeof document === 'undefined') return;

  function $(id) { return document.getElementById(id); }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  // Halve tal: før blev ".5" til Unicode-"½", som rendrer i fuld højde og
  // crowder nabotallet ("1½×" så rodet ud). Nu pakkes brøken i en lille
  // styled span (tp-frac) der sidder neat ved siden af heltallet. Bruges
  // kun i HTML-kontekster (dose-fliser, portioner, varighed) — alle dens
  // forbrugere skriver til innerHTML. FASE 7.28.0.
  function fmtHalf(u) {
    var s = ('' + u).replace(/\.5$/, '½').replace(/^0½/, '½');
    return s.replace('½', '<span class="tp-frac">½</span>');
  }
  // Ren tekst-variant (ingen HTML) til aria-labels o.l. hvis nødvendigt.
  function fmtHalfText(u) {
    return ('' + u).replace(/\.5$/, '½').replace(/^0½/, '½');
  }

  // Snap-punkter til "Indtast selv" — kalibreret mod hvad markedet
  // faktisk sælger (CSV-analyse af shoppens egne produkter, jun 2026).
  // Gel klumper om 30 g; pulver har knuder ved 20/30/40/55/80/90.
  // FASE 7.32.0: 45 g tilføjet til gel (Victus-gels på lager) — rammer
  // mellemlange tempopas bedre (fx 1½ t tempo: 2 × 45 = 90 g lander i
  // bunden af båndet, hvor 2 × 40 = 80 g er i underkanten).
  var SNAP = {
    gel: { steps: [20, 25, 30, 40, 45], def: 30 },
    pulver: { steps: [20, 30, 40, 55, 80, 90], def: 40 }
  };

  // UI-tilstand. Sport og intensitet er forvalgt — varigheden er det
  // ene tryk der skal til, før svaret kommer. mode: 'vaelg'|'custom'
  // pr. form-type. customG: gram pr. styk i custom-tilstand.
  // Træningstype → intensitet (zone-mapping, FASE 7.4.0).
  // Easy=Z1-2=let, Tempo=Z3=moderat, Interval+VO2max=Z4-5=hård.
  var TRAINTYPE = {
    easy:     { intensity: 'let',     label: 'Easy',    zone: 'Z1–Z2', train: 'rolig træning' },
    tempo:    { intensity: 'moderat', label: 'Tempo',   zone: 'Z3', train: 'tempotræning' },
    interval: { intensity: 'haard',   label: 'Interval', zone: 'Z4', train: 'intervaltræning' },
    vo2:      { intensity: 'haard',   label: 'VO2 max', zone: 'Z5', train: 'VO2 max-træning' }
  };

  var st = {
    sport: 'loeb', minutes: 90, form: null,
    customG: { pulver: SNAP.pulver.def, gel: SNAP.gel.def },
    stomach: 'fyldt',  // 'fyldt' | 'tom' — styrer kun første-gel-timing
    gut: null,         // null | 90 | 120 — mavetolerance-mål, overstyrer båndet
    trainType: 'easy',     // standard: 1½ time, Easy (FASE 7.26.0 — åbner med en synlig brændstofplan)
    view: 'total',         // 'total' | 'time' — resultatets switch (FASE 7.13.0)
    numbersOpen: false,
    planOpen: false        // "Sådan gør du undervejs"-fold (FASE 7.13.0)
  };
  // Den effektive intensitet kommer altid fra træningstypen (FASE 7.8.0).
  function effIntensity() {
    return TRAINTYPE[st.trainType].intensity;
  }

  // ══════════════════════════════════════════════════
  //  TRACKING (Microsoft Clarity) — FASE 7.25.0
  //  Samme mønster som guiden (sport-energy-guide.js): events via
  //  clarity('event', navn) og tags via clarity('set', tag, værdi).
  //  Clarity loades på tema-niveau, så window.clarity findes allerede.
  //  Fejler stille hvis den ikke er der (fx i test/standalone uden net).
  //  Event-præfiks: 'traening_'. Tag-præfiks: 'tr_' (parallelt til guidens
  //  'guide_'), så de er nemme at filtrere i Clarity.
  // ══════════════════════════════════════════════════
  function seg_track(eventName, props) {
    try {
      if (typeof window.clarity !== 'function') return;
      window.clarity('event', eventName);
      if (props && typeof props === 'object') {
        for (var key in props) {
          if (Object.prototype.hasOwnProperty.call(props, key)) {
            var value = props[key];
            if (value === null || value === undefined || value === '') continue;
            window.clarity('set', 'tr_' + key, String(value));
          }
        }
      }
    } catch (e) { /* stille fejl */ }
  }
  // Fælles snapshot af det aktuelle valg — bruges som tags på de fleste
  // events, så hvert event kan ses i sin kontekst.
  function trackContext() {
    return {
      sport: st.sport,
      minutes: st.minutes,
      traintype: st.trainType,
      intensity: effIntensity(),
      form: st.form || 'none'
    };
  }
  // Resultat-event er DEBOUNCED: recalc() kører ved hvert tastetryk/træk,
  // så vi venter ~1,2 s efter sidste ændring og logger så det FÆRDIGE pas
  // (config + beregnet kulhydrat/væske). Det giver ét rent "hvad endte de
  // med"-signal i stedet for støj på hver mikro-justering.
  var _resultTimer = null;
  function trackResultDebounced(S) {
    if (!S || !S.ok) return;
    if (_resultTimer) clearTimeout(_resultTimer);
    var snapshot = {
      sport: st.sport, minutes: st.minutes, traintype: st.trainType,
      intensity: S.intensity, form: st.form || 'none',
      carbs_g: S.carbsG, fluid_ml: S.fluidMl,
      water_only: S.waterOnly ? 'yes' : 'no'
    };
    _resultTimer = setTimeout(function () {
      seg_track('traening_result', snapshot);
    }, 1200);
  }
  function isCykel() { return st.sport === 'cykel'; }

  // ── Sport-ordforråd samlet ét sted (FASE 7.23.0, ordlyd 7.29.0). Begge
  // sporter siger "flaske" — cyklister sætter den i holderen, løbere i
  // vesten. ("Bidon" var for niche; danske cyklister siger også flaske.)
  // Ét opslag, så ordlyden ikke driver fra hinanden rundt i koden. ──
  function sportTerms() {
    if (isCykel()) {
      return {
        bottle1: 'Flaske', bottleN: 'Flasker', bottleLc: 'flaske', stepMark: 'Flaske',
        // Vand-rækker-noten: cyklister tager en flaske i holderen.
        waterNote: 'Tag eventuelt en <strong>flaske 500 ml med elektrolyt</strong> i holderen, hvis det er varmt eller du sveder meget. Ellers: bare kør.',
        // Høj-svedrate-noten.
        sweatNote: 'Sveder du meget i varmen, så tag en <strong>ekstra flaske</strong> med, to i holderen, så du ikke løber tør.',
        // Pulver-anbefaling: flasken drikkes roligt, så koncentrationen må gerne være højere.
        pulverRec: 40,
        pulverNote: function (t) { return '40 g pr. flaske er fint på cyklen, flasken drikkes roligt fra holderen, så høj koncentration giver sjældent maveuro i løbet af ' + t + '. Ram dit kulhydrat-mål ved at supplere med gels.'; }
      };
    }
    return {
      bottle1: 'Flaske', bottleN: 'Flasker', bottleLc: 'flaske', stepMark: 'Flaske',
      waterNote: 'Tag eventuelt en <strong>softflaske 500 ml med elektrolyt</strong> med, hvis det er varmt eller du sveder meget. Ellers: bare løb.',
      sweatNote: 'Sveder du meget i varmen, så tag en <strong>større flaske</strong>, eller en blære i vesten, så du ikke løber tør.',
      pulverRec: 30,
      pulverNote: function (t) { return 'Hold pulveret på maks. 30 g pr. portion, lavere koncentration er nemmere for maven i løbet af ' + t + '. Ram dit kulhydrat-mål ved at tage gels ved siden af'; }
    };
  }

  // ── Varigheds-hurtigvalg pr. sport (FASE 7.23.0). Løb: korte til
  // mellemlange (45 min–3 t). Cykel: ingen 45 min (få vælger så kort en
  // cykeltur), til gengæld 4 og 5 t som mange cyklister reelt kører. ──
  function durChips() {
    return isCykel()
      ? [[60, '1 t'], [120, '2 t'], [180, '3 t'], [240, '4 t'], [300, '5 t']]
      : [[45, '45 min'], [60, '1 t'], [90, '1<span class="tp-frac">½</span> t'], [120, '2 t'], [180, '3 t']];
  }
  function renderDurChips() {
    var box = $('tp-dur-quick');
    if (!box) return;
    var chips = durChips(), html = '';
    for (var i = 0; i < chips.length; i++) {
      html += '<button type="button" class="tp-dur-chip" onclick="TP.setDur(' + chips[i][0] + ')">' + chips[i][1] + '</button>';
    }
    box.innerHTML = html;
  }

  // ── Anbefalet størrelse på sliderne — PARKERET (FASE 7.24.2). ──
  // Systemet er midlertidigt slået FRA, mens det gentænkes offline. Det
  // var for restriktivt: på en tempotime kan man fint drikke energipulver
  // (fx 60 g i én flaske), men anbefalingen skubbede mod 20–30 g + flere
  // portioner, og på "begge" sad pulver-anbefalingen selvom gels netop
  // tager kulhydraterne — inkonsistent. Funktionen returnerer derfor null,
  // hvilket fjerner HELE anbefalings-UI'et rent: ingen orange prik, ingen
  // ramme-note, ingen "Anbefalet"-knap (alle guards er recIdx >= 0).
  // Sliderne virker præcis som før funktionen fandtes.
  //
  // GENOPLIVNING: fjern den tidlige `return null;` herunder, så er den
  // gamle logik (bevaret nedenfor) aktiv igen. Gentænk først: hvornår er
  // en anbefaling reelt nyttig vs. blot begrænsende, og hvordan hænger
  // den sammen med det faktiske resultat ("3× pulver" osv.).
  function recommendedSize(kind) {
    return null; // PARKERET — se note ovenfor.
    /* eslint-disable no-unreachable */
    var eff = effIntensity();
    if (eff !== 'haard' && eff !== 'moderat') return null; // tempo + hårde pas
    if (st.form === 'gel') return kind === 'gel' ? (eff === 'haard' ? 40 : 30) : null;
    // Pulver-koncentrationen er sport-afhængig: løb 30 g (mavehensyn),
    // cykel 40 g (bidonen drikkes roligt fra holderen). FASE 7.23.0.
    var pRec = sportTerms().pulverRec;
    if (st.form === 'pulver') return kind === 'pulver' ? pRec : null;
    if (st.form === 'begge') return kind === 'pulver' ? pRec : null; // kun pulver
    return null;
    /* eslint-enable no-unreachable */
  }
  // Kort begrundelse til teksten ved prikken (kun brugt når systemet er
  // aktivt) — nævner den konkrete træningstype på naturligt dansk.
  function recommendedNote(kind) {
    var t = TRAINTYPE[st.trainType].train;
    if (st.form === 'gel') {
      // Tempo: 30 g geler rammer båndet pænt; hårde pas: færre geler.
      return effIntensity() === 'haard'
        ? 'Færre gels at indtage i løbet af ' + t
        : 'To geler à 30 g rammer dit behov pænt, uden at overskyde';
    }
    // Pulver alene eller begge: ordlyden afhænger af sporten. FASE 7.23.0.
    return sportTerms().pulverNote(t);
  }

  // ── Dine tal: målt fra profilen, ellers stille Normal-forvalg ──
  function sweatValue() {
    var measured = window.SportEnergyProfile ? window.SportEnergyProfile.getSweatRate() : null;
    if (measured) return measured;
    var r = document.querySelector('input[name="tp-sweat"]:checked');
    return r ? parseInt(r.value, 10) : 900;
  }
  // Natrium-koncentration (mg pr. liter sved) fra svedtestens niveau.
  // Uden måling: normal. Bruges kun til en rolig rettesnor, ikke en
  // dæknings-beregning (race-kittets job).
  var NA_PER_L = { lav: 450, normal: 700, salt: 1000 };
  function sodiumPerL() {
    var level = window.SportEnergyProfile ? window.SportEnergyProfile.getSodium() : null;
    return NA_PER_L[level] || 700;
  }
  // Natrium-mål pr. time = 500 ml/t (liter) × mg/L, rundet til 50.
  // Matcher væske-flisen (1 flaske i timen), FASE 7.6.0.
  function sodiumPerHour() {
    return Math.round(500 / 1000 * sodiumPerL() / 50) * 50;
  }
  // Som bånd (±50 om målet) — natrium-behov er heller ikke et punkt.
  function sodiumBand() {
    var mid = sodiumPerHour();
    return (mid - 50) + '–' + (mid + 50);
  }

  // ── Designsystem: ikoner, fliser, noter (delt sprog med race-kit) ──
  var SEI = {
    drop: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3.5s5.5 6.1 5.5 10a5.5 5.5 0 1 1-11 0c0-3.9 5.5-10 5.5-10z"/></svg>',
    bag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M5.5 8h13l-1 12h-11l-1-12z"/><path d="M8.5 8V6.5a3.5 3.5 0 0 1 7 0V8"/></svg>',
    bulb: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-4 10.5c.7.7 1 1.2 1 2.5h6c0-1.3.3-1.8 1-2.5A6 6 0 0 0 12 3z"/></svg>',
    clock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>',
    // Pakke-ikoner til dose-fliserne (FASE 7.12.0), samme 1.75-stroke.
    // Gel = sachet med takket forsegling foroven; flaske = softflaske
    // (genbrugt fra race-kittet); pulver = pose.
    gel: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M8.5 6.5 9 4.6l1.2 1 1.3-1 1.3 1 1.2-1 .5 1.9"/><path d="M8.5 6.5h7v11a2.5 2.5 0 0 1-2.5 2.5h-2A2.5 2.5 0 0 1 8.5 17.5V6.5z"/><path d="M10.5 11h3"/></svg>',
    bottle: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M10 3h4"/><path d="M10.5 3v3.2L8.8 9a3 3 0 0 0-.3 1.3V19a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-8.7a3 3 0 0 0-.3-1.3L13.5 6.2V3"/></svg>',
    powder: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M7.5 4.5h9l-1 3h-7z"/><path d="M6.5 7.5h11V19a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V7.5z"/><path d="M10 12h4M10 15.5h4"/></svg>',
    chev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>'
  };
  // Vælg ikon ud fra dækningsform til dose-flisen.
  function doseIcon(kind) {
    return kind === 'gel' ? SEI.gel : kind === 'pulver' ? SEI.powder : SEI.bottle;
  }
  function statTile(v, l) { return '<div class="rk-stat"><span class="rk-stat-v">' + v + '</span><span class="rk-stat-l">' + l + '</span></div>'; }
  function noteRow(ico, inner) {
    return '<div class="rk-note"><span class="rk-note-ico">' + ico + '</span><p>' + inner + '</p></div>';
  }
  // Varigheds-label til head: præcis visning (1 t 15 min). FASE 7.10.0.
  function durLabel(min) {
    var h = Math.floor(min / 60), m = min % 60;
    if (h === 0) return m + ' min';
    if (m === 0) return h === 1 ? '1 time' : h + ' timer';
    return h + ' t ' + m + ' min';
  }
  function sodiumWord(level) { return level === 'lav' ? 'lavt' : level === 'salt' ? 'salt sved' : 'normalt'; }

  // ── Træningstype (FASE 7.8.0: intensitet-toggle fjernet — én
  // indgang er enklere). Easy/Tempo/Interval/VO2 max mapper til de tre
  // bånd; zonen vises under hver. ──
  function renderIntensity() {
    var box = $('tp-intensity');
    if (!box) return;
    box.innerHTML = '<span class="sv-label">Træningstype</span>'
      + '<div class="tp-type-grid">'
      + typeOpt('easy') + typeOpt('tempo') + typeOpt('interval') + typeOpt('vo2')
      + '</div>';
  }
  function typeOpt(key) {
    var t = TRAINTYPE[key];
    return '<button type="button" class="tp-type-btn" aria-pressed="' + (st.trainType === key ? 'true' : 'false')
      + '" onclick="TP.setTrainType(\'' + key + '\')">'
      + '<span class="tp-type-l">' + t.label + '</span><span class="tp-type-z">' + t.zone + '</span></button>';
  }

  // ── Flaske-sprog: løbere pakker vest, cyklister sætter på cyklen ──
  // FASE 7.2.0: antal flasker = antal timer, ikke væskevolumen.
  // Atleten drikker ~1 flaske (500 ml) i timen; har de brug for mere,
  // bruger de en STØRRE flaske, ikke flere. Edge-casen (høj svedrate)
  // håndteres med en note, ikke en omregning.
  //
  // FASE 7.10.0: skæve varigheder. Resten ud over hele timer rundes
  // som en atlet mentalt pakker — ikke som matematik:
  //   0–19 min rest → forsvinder (stadig N flasker)
  //   20–49 min rest → en halv flaske (N½)
  //   50–59 min rest → rundes op til en hel (N+1)
  // (Phillips egen tankegang: 75 min = 1 flaske, 80 = 1½, 1t50 = 2.)
  function bottlePlan() {
    var full = Math.floor(st.minutes / 60);
    var rest = st.minutes % 60;
    var half = false;
    if (rest >= 50) full += 1;
    else if (rest >= 20) half = true;
    if (full === 0 && !half) full = 1; // mindst noget at drikke
    return { full: full, half: half, rest: rest };
  }

  // ── Dine tal: sammenfoldet til én linje, åbnes ved tryk ──
  function renderNumbers() {
    var box = $('tp-numbers');
    if (!box) return;
    var P = window.SportEnergyProfile;
    var measured = P ? P.getSweatRate() : null;
    var level = P ? P.getSodium() : null;

    var html = '<button type="button" class="tp-fold-head" aria-expanded="' + (st.numbersOpen ? 'true' : 'false')
      + '" onclick="TP.toggleNumbers()">'
      + '<span class="tp-fold-ico" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h10M18 7h2M4 17h2M10 17h10"/><circle cx="16" cy="7" r="2"/><circle cx="8" cy="17" r="2"/></svg></span>'
      + '<span class="tp-fold-name">Personlige indstillinger</span>'
      + '<span class="tp-fold-caret" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg></span>'
      + '</button>';

    if (st.numbersOpen) {
      html += '<div class="tp-fold-body">';
      if (measured) {
        html += '<div class="sv-banner"><span>Svedrate: <strong>' + measured + ' ml i timen</strong>'
          + (level ? ' · natrium <strong>' + sodiumWord(level) + '</strong>' : '')
          + ', dine målte tal bruges.</span>'
          + '<a class="sv-delete" href="/pages/svedtest">Ny måling</a></div>';
      } else {
        html += '<div class="sv-field"><span class="sv-label">Svedrate</span>'
          + '<div class="rk-radio-row se-seg" style="--seg-n: 3; --seg-i: 1; grid-template-columns: repeat(3, 1fr);">'
          + '<label class="seg-opt"><input type="radio" name="tp-sweat" value="600" onchange="TP.setSweat(this.value)"><span>Lav</span></label>'
          + '<label class="seg-opt"><input type="radio" name="tp-sweat" value="900" checked onchange="TP.setSweat(this.value)"><span>Normal</span></label>'
          + '<label class="seg-opt"><input type="radio" name="tp-sweat" value="1300" onchange="TP.setSweat(this.value)"><span>Høj</span></label></div>'
          + '<p class="sv-foot" style="margin-top:8px">Få dit eget tal med <a href="/pages/svedtest">svedtesten</a>, så husker beregneren det.</p></div>';
      }
      // Mave-tilstand: styrer kun hvornår første gel falder i planen.
      html += '<div class="sv-field" style="margin-top:14px"><span class="sv-label">Træner du på tom eller fyldt mave?</span>'
        + '<div class="rk-radio-row se-seg" style="--seg-n: 2; --seg-i: ' + (st.stomach === 'tom' ? 1 : 0) + '; grid-template-columns: repeat(2, 1fr);">'
        + '<label class="seg-opt"><input type="radio" name="tp-stomach" value="fyldt"' + (st.stomach === 'fyldt' ? ' checked' : '') + ' onchange="TP.setStomach(this.value)"><span>Fyldt</span></label>'
        + '<label class="seg-opt"><input type="radio" name="tp-stomach" value="tom"' + (st.stomach === 'tom' ? ' checked' : '') + ' onchange="TP.setStomach(this.value)"><span>Tom</span></label>'
        + '</div>'
        + '<p class="sv-foot" style="margin-top:8px">'
        + (st.stomach === 'tom'
            ? 'På tom mave er der intet insulin-respons at forstyrre, første gel kan komme tidligt.'
            : 'Med mad i maven venter vi lidt med første gel, så blodsukkeret falder til ro først.')
        + '</p></div>';
      // Mavetolerance: overstyrer båndet til 90/120 g/t. Default af.
      var gOn = st.gut === 90 || st.gut === 120;
      html += '<div class="sv-field" style="margin-top:14px"><span class="sv-label">Træn mavetolerance</span>'
        + '<div class="rk-radio-row se-seg" style="--seg-n: 3; --seg-i: ' + (st.gut === 90 ? 1 : st.gut === 120 ? 2 : 0) + '; grid-template-columns: repeat(3, 1fr);">'
        + '<label class="seg-opt"><input type="radio" name="tp-gut" value="off"' + (!gOn ? ' checked' : '') + ' onchange="TP.setGut(\'off\')"><span>Fra</span></label>'
        + '<label class="seg-opt"><input type="radio" name="tp-gut" value="90"' + (st.gut === 90 ? ' checked' : '') + ' onchange="TP.setGut(\'90\')"><span>90 g/t</span></label>'
        + '<label class="seg-opt"><input type="radio" name="tp-gut" value="120"' + (st.gut === 120 ? ' checked' : '') + ' onchange="TP.setGut(\'120\')"><span>120 g/t</span></label>'
        + '</div>'
        + '<p class="sv-foot" style="margin-top:8px">'
        + (gOn
            ? 'Beregneren sigter efter ' + st.gut + ' g i timen ved hver træning, uanset intensitet. Sådan vænnes tarmen til mængden.'
            : 'Slå til hvis du bevidst træner maven til at tåle mere energi. Ellers sigter beregneren efter den lave, mavevenlige ende.')
        + '</p></div>';
      // Elektrolyt: forklaringen gemt væk her — i resultatet står
      // natrium-rettesnoren som tal i pakkelisten i stedet.
      html += '<p class="sv-foot tp-na-explain">Sveden tager mere salt, end vand giver tilbage. '
        + 'Derfor står et natrium-mål i pakkelisten, vælg produkter med elektrolyt nok til at ramme det.</p>';
      html += '</div>';
    }
    box.innerHTML = html;
  }

  // ── Dækningen bor nu i INPUT-kortet under træningstype (FASE 7.13.0):
  // form-valg + gram-slidere. Resultatet er kun resultatet. ──
  function renderCoverage() {
    var box = $('tp-coverage');
    if (!box) return;
    var html = '<span class="sv-label">Hvad tager du med?</span>'
      + '<div class="tp-chips tp-form-row tp-form-light">'
      + formChip('pulver', 'Energipulver') + formChip('gel', 'Gels') + formChip('begge', 'Begge')
      + '</div>';
    if (st.form === 'pulver') html += pickerBlock('pulver');
    else if (st.form === 'gel') html += pickerBlock('gel');
    else if (st.form === 'begge') html += pickerBlock('pulver') + pickerBlock('gel');
    box.innerHTML = html;
  }
  function formChip(val, label) {
    return '<button type="button" class="tp-chip" aria-pressed="' + (st.form === val ? 'true' : 'false')
      + '" onclick="TP.setForm(\'' + val + '\')">' + label + '</button>';
  }

  // Ét slider-blok pr. type. "Vælg produkt" er udgået (FASE 7.2.0) —
  // slideren er den eneste, universelle vej; den hjælper atleten uanset
  // mærke. Broen til shoppen lever nu i shop-knappen i bunden.
  function pickerBlock(kind) {
    var labelTxt = kind === 'pulver' ? 'Energipulver' : 'Gel';
    return '<div class="tp-picker" data-kind="' + kind + '">'
      + '<div class="tp-picker-head"><span class="sv-label">' + labelTxt + '</span></div>'
      + sliderHTML(kind)
      + '</div>';
  }

  // Slider med snap-punkter. Native range for fingervenlighed; trin
  // er indeks i SNAP.steps, så pillen klikker fast på rigtige tal.
  function sliderHTML(kind) {
    var steps = SNAP[kind].steps;
    var cur = st.customG[kind];
    var idx = steps.indexOf(cur); if (idx < 0) idx = 0;
    var rec = recommendedSize(kind);        // anbefalet tal eller null
    var recIdx = rec != null ? steps.indexOf(rec) : -1;
    var ticks = '';
    for (var i = 0; i < steps.length; i++) {
      var isRec = i === recIdx;
      ticks += '<button type="button" class="tp-tick' + (i === idx ? ' is-on' : '')
        + (isRec ? ' is-rec' : '') + '"'
        + ' onclick="TP.snap(\'' + kind + '\',' + i + ')">' + steps[i] + '</button>';
    }
    var html = '<div class="tp-slider' + (recIdx >= 0 ? ' has-rec' : '') + '">'
      + '<div class="tp-track-wrap">'
      + '<input type="range" class="tp-range" min="0" max="' + (steps.length - 1) + '" step="1" value="' + idx + '"'
      + ' aria-label="Kulhydrat pr. ' + (kind === 'pulver' ? 'portion' : 'gel') + '"'
      + ' oninput="TP.slide(\'' + kind + '\',this.value)">';
    // Anbefalings-prik placeret med SAMME geometri som thumb'en: thumb-
    // centret rejser fra 13px-inset til (100% − 13px), så for trin i ud
    // af (n−1) sidder centret ved calc(13px + (100% − 26px) × frac). Vi
    // sætter --rec-frac og lader CSS regne — så prikken rammer thumb-
    // sporet præcist (før: prikken lå på tick'ens flex-position, som ikke
    // matcher thumb-insettet i enderne). FASE 7.22.0.
    if (recIdx >= 0) {
      var denom = steps.length - 1 || 1;
      var frac = recIdx / denom;
      html += '<span class="tp-rec-marker" aria-hidden="true" style="--rec-frac: ' + frac + '"></span>';
    }
    html += '</div>'
      + '<div class="tp-ticks">' + ticks + '</div>'
      + '<div class="tp-slider-val">' + cur + ' g kulhydrat pr. ' + (kind === 'pulver' ? 'portion' : 'gel') + '</div>';
    // Tryk-bar anbefaling: prikken hvisker, ét tryk hopper derhen.
    // Knappen renderes ALTID når der findes en anbefaling — også når man
    // allerede står på den (så skjult) — så slide() kan vise den igen
    // uden en fuld re-render. FASE 7.16.1.
    if (recIdx >= 0) {
      var hide = rec === cur ? ' style="display:none"' : '';
      html += '<button type="button" class="tp-rec"' + hide + ' onclick="TP.snap(\'' + kind + '\',' + recIdx + ')">'
        + '<span class="tp-rec-dot" aria-hidden="true"></span>'
        + '<span class="tp-rec-txt"><strong>Anbefalet: ' + rec + ' g</strong>, ' + recommendedNote(kind) + '</span>'
        + '</button>';
    }
    html += '</div>';
    return html;
  }

  // ── Hvad dækker den valgte form? Altid slider-værdien (FASE 7.2.0) ──
  function unitFor(kind) {
    var g = st.customG[kind];
    return { carbsG: g, word: kind === 'pulver' ? 'Pulver' : 'Gel' };
  }

  // ── Dose-flise (FASE 7.15.0): ikon-repetition over én fed linje
  // "1× Gel" — enhed sammen med tallet, ingen undertekst. ──
  function doseTile(count, word, ico) {
    var icons = '';
    if (ico) {
      var whole = Math.floor(count || 0);
      var reps = whole > 0 ? whole : 1; // mindst ét ikon (også for ½)
      for (var i = 0; i < reps; i++) icons += '<span class="tp-dose-ico">' + ico + '</span>';
      icons = '<div class="tp-dose-icons">' + icons + '</div>';
    }
    return '<div class="tp-dose-tile">' + icons
      + '<span class="tp-dose-big"><span class="tp-dose-n">' + fmtHalf(count)
      + '×</span> <span class="tp-dose-w">' + word + '</span></span></div>';
  }

  // Antal geler til at dække et behov. Vi runder normalt OP, men hvis
  // én færre gel allerede dækker ≥85 % af behovet, er den ekstra gel
  // grov overfyldning (45 g behov med 40 g geler = 1 gel, ikke 2). Det
  // gør især anbefalingen om større geler meningsfuld. FASE 7.16.0.
  // ── Gel-fordeling (FASE 7.31.0). Gelerne fordeles JÆVNT over et VINDUE
  // der starter lidt inde og slutter et stykke før mål — i stedet for at
  // hver gel "ejer" helt ud til kanterne. Det holder gelerne væk fra
  // enderne: ikke for tidligt (maven er ikke klar de første minutter på en
  // tempotur) og ikke for sent (sidste gel skal nå at virke ~15–20 min før
  // slut). Konkret på 1 t / 2 geler: 0:20 og 0:40 (før: 0:15/0:45, hvor den
  // sidste lå for sent). Vinduet:
  //   start = ~20 min (15 på tom mave), rykket ind på korte pas
  //   slut  = T − hale (hale 20 min på korte pas ≤90, ellers 15)
  // Geler lægges med lige store mellemrum mellem start og slut. På meget
  // korte pas sikres et minimums-mellemrum (15 min) så de ikke klumper.
  function gelSchedule(n) {
    var T = st.minutes;
    var floor = st.stomach === 'tom' ? 15 : 20;       // tidligste første gel
    var tail = T <= 90 ? 20 : 15;                      // sidste gel før slut
    var minGap = 15;
    var startMin = Math.min(floor, Math.round(T / (n + 1) / 5) * 5); // korte pas: ryk ind
    var endMin = T - tail;
    // Sikr plads til n geler med et fornuftigt mellemrum; ellers slæk halen.
    if (n > 1 && (endMin - startMin) < minGap * (n - 1)) {
      endMin = startMin + minGap * (n - 1);
      if (endMin > T - 5) { endMin = T - 5; startMin = Math.max(5, endMin - minGap * (n - 1)); }
    }
    var times = [];
    if (n === 1) {
      times = [Math.round((startMin + endMin) / 2 / 5) * 5];
    } else {
      var step = (endMin - startMin) / (n - 1);
      for (var k = 0; k < n; k++) times.push(Math.round((startMin + step * k) / 5) * 5);
    }
    var interval = times.length > 1 ? (times[1] - times[0]) : Math.round((endMin - startMin) / 5) * 5;
    return { first: times[0], interval: interval, times: times };
  }
  function gelCount(needG, gelG) {
    if (needG <= 0) return 0;
    var down = Math.floor(needG / gelG);
    var up = Math.ceil(needG / gelG);
    if (down >= 1 && (down * gelG) >= needG * 0.85) return down;
    return Math.max(1, up);
  }
  // Bevaret til den ene-gel-sti og evt. andre kald (FASE 7.16.0).
  function firstGelMin() {
    var base = st.stomach === 'tom' ? 15 : 30;
    var capByLength = Math.max(10, Math.round(st.minutes / 3 / 5) * 5);
    return Math.min(base, capByLength);
  }
  function intervalWord(min, firstMin) {
    var base = min >= 60 ? 'hver time' : 'hver ' + min + '. min';
    var first = Math.floor(firstMin / 60) + ':' + String(firstMin % 60).padStart(2, '0');
    return base + ' · start ' + first;
  }
  // Gel-rytme til step-listen (FASE 7.15.0, justeret 7.29.0). Én gel får
  // en konkret timing ca. MIDTVEJS på passet — sent nok til ikke at
  // spildes på fuld mave, tidligt nok til at nå at virke før slut. Flere
  // geler fordeles jævnt via gelSchedule. ──
  function singleGelMin() {
    var mid = Math.round(st.minutes / 2 / 5) * 5;     // midtvejs, til nærmeste 5
    var floor = firstGelMin();                         // ikke før mavehensyn tillader
    var ceil = Math.max(floor, st.minutes - 15);       // skal nå at virke
    return Math.min(Math.max(mid, floor), ceil);
  }
  function fmtClock(min) {
    return Math.floor(min / 60) + ':' + String(min % 60).padStart(2, '0');
  }
  function gelStepText(n) {
    if (n <= 1) {
      // Én gel: tag den ca. midtvejs. På korte pas bliver det reelt et
      // par-og-tyve minutter inde; på fx 1 t 30 omkring 0:45.
      var t = singleGelMin();
      var when = t < 60 ? 'efter ca. ' + t + ' min' : 'efter ca. ' + fmtClock(t);
      return '<strong>1 gel</strong> ' + when;
    }
    var sch = gelSchedule(n);
    return '<strong>1 gel</strong> ' + intervalWord(sch.interval, sch.first) + ' (' + n + ' i alt)';
  }
  // Gel-trin som en konkret TIDSLISTE (FASE 7.30.0). I stedet for én
  // rytme-linje ("hver 40. min · start 0:20") viser vi hvert gel-tidspunkt
  // som sin egen række: klokkeslæt i mærke-kolonnen, "1. gel" i teksten.
  // Det er nemmere at handle på og mere app-agtigt. For MANGE geler (>5)
  // bliver en literal liste støj — der falder vi tilbage til rytme-linjen.
  // Returnerer en ARRAY af stepRow-strenge.
  function gelStepRows(n) {
    if (n <= 1) {
      return [stepRow('Gel', gelStepText(n))];
    }
    var sch = gelSchedule(n);
    if (n > 5) {
      // For lange pas: én samlet rytme-linje i stedet for en lang liste.
      return [stepRow('Gel', gelStepText(n))];
    }
    var rows = [];
    for (var i = 0; i < sch.times.length; i++) {
      var clock = fmtClock(sch.times[i]);
      rows.push(stepRow(clock, '<strong>' + (i + 1) + '. gel</strong>'));
    }
    return rows;
  }
  // Flaske-step der matcher den FAKTISKE mængde øverst (FASE 7.15.0).
  // Sub-time: konkret ml (= samme som "væske i alt" øverst) uden "i
  // timen". Over en time: rytmen pr. time.
  function flaskStepText(fluidMl) {
    var plan = bottlePlan();
    var b = sportTerms().bottleLc;
    if (plan.full >= 1) {
      return '<strong>1 ' + b + ' 500 ml</strong> vand med/uden elektrolyt i timen';
    }
    // Sub-time: vis nøjagtig den mængde resultatet viser øverst.
    return '<strong>Drik 1 ' + b + ' ' + fluidMl + ' ml</strong> vand med/uden elektrolyt undervejs';
  }

  // ── "Sådan gør du undervejs" som en ren lodret plan (FASE 7.8.0).
  // Hvert trin er én linje: et lille label-mærke + handlingen. Erstatter
  // de tidligere konkurrerende fliser, der blandede flaske-fordeling og
  // gel-rytme. ──
  function stepRow(mark, text) {
    return '<div class="tp-step"><span class="tp-step-mark">' + mark + '</span>'
      + '<span class="tp-step-txt">' + text + '</span></div>';
  }
  function stepBlock(rows) {
    var open = st.planOpen;
    return '<div class="tp-steps' + (open ? ' is-open' : '') + '">'
      + '<button type="button" class="tp-steps-toggle" aria-expanded="' + (open ? 'true' : 'false') + '" onclick="TP.togglePlan()">'
      + '<span class="tp-steps-ico" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="6" cy="6" r="2"/><circle cx="6" cy="18" r="2"/><path d="M6 8v8"/><path d="M12 6h5a2 2 0 0 1 2 2v0a2 2 0 0 1-2 2h-5"/><path d="M12 18h6"/></svg></span>'
      + '<span class="sv-result-kicker tp-act-head">Sådan gør du undervejs</span>'
      + '<span class="tp-steps-chev" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg></span></button>'
      + '<div class="tp-steps-body">' + rows.join('') + '</div></div>';
  }

  // ── Diskret tip når SMÅ geler kræver mange at bære (større gel
  // sparer doser). Vises kun når en større snap-størrelse reelt
  // sparer doser. ──
  function gelTip(perGelG, totalCarbsG) {
    var n = Math.max(1, Math.ceil(totalCarbsG / perGelG));
    if (n < 6) return null; // få nok geler — ingen grund til at nævne det
    var bigger = null;
    for (var i = 0; i < SNAP.gel.steps.length; i++) {
      if (SNAP.gel.steps[i] > perGelG) bigger = SNAP.gel.steps[i];
    }
    if (!bigger) return null;
    var nBig = Math.max(1, Math.ceil(totalCarbsG / bigger));
    if (nBig >= n - 1) return null; // sparer ikke nok til at nævne
    return n + ' × ' + perGelG + ' g geler er en del at bære og åbne undervejs. '
      + 'En ' + bigger + ' g gel ville klare det på ' + nBig + '. Færre at holde styr på.';
  }
  // ── Dæknings-note (FASE 7.32.1): fortæller hvornår en ANDEN gel-størrelse
  // rammer kulhydrat-MÅLET bedre med det aktuelle antal geler. Det er her
  // 45 g-gelen får mening: på fx 1½ t tempo (mål ~90 g) giver 2 × 40 = 80 g
  // (i underkanten), mens 2 × 45 = 90 g rammer båndet. Symmetrisk — hvis den
  // valgte gel OVERskyder, peger den nedad i stedet. Vises kun når der findes
  // en snap-størrelse der lander tættere på/inde i båndet. ──
  function gelCoverageNote(perGelG, S) {
    if (!S.band || S.gutActive || !S.perHour) return null; // intet bånd at ramme
    // Båndet er PR. TIME; gel-totalen er for HELE passet. Omregn båndet til
    // total via passets timer (carbsG = perHour × timer, så timer udledes).
    var hours = S.carbsG / S.perHour;
    var gMin = Math.round(S.band.gMin * hours);
    var gMax = Math.round(S.band.gMax * hours);
    var n = gelCount(S.carbsG, perGelG);
    var total = n * perGelG;
    var inBand = total >= gMin - 3 && total <= gMax + 3;
    if (inBand) return null;                           // rammer allerede
    // Find den bedste alternative gel-størrelse. Prioritet: (1) lander i
    // båndet, (2) færrest geler, (3) total tættest på motorens mål (carbsG).
    var best = null, bestN = 0, bestTotal = 0;
    for (var i = 0; i < SNAP.gel.steps.length; i++) {
      var sz = SNAP.gel.steps[i];
      if (sz === perGelG) continue;
      var cN = gelCount(S.carbsG, sz);
      var t = cN * sz;
      var tIn = t >= gMin - 3 && t <= gMax + 3;
      if (!tIn) continue;                              // skal lande i båndet
      if (cN > n) continue;                            // aldrig FLERE geler (upraktisk)
      if (best === null
          || cN < bestN
          || (cN === bestN && Math.abs(t - S.carbsG) < Math.abs(bestTotal - S.carbsG))) {
        best = sz; bestN = cN; bestTotal = t;
      }
    }
    if (best === null) return null;
    var dir = total < gMin ? 'i underkanten' : 'i overkanten';
    return 'Med ' + n + ' × ' + perGelG + ' g rammer du ' + total + ' g, ' + dir
      + ' af målet (' + gMin + '–' + gMax + ' g). '
      + bestN + ' × ' + best + ' g rammer ' + bestTotal + ' g, lige i båndet.';
  }
  // ── Blød nudge mod pulver/begge på lange pas: 6+ geler i lommen er
  // upraktisk uanset størrelse. Coach-tone, ikke salg. ──
  function gelNudge(n) {
    if (n < 6) return null;
    return 'På en så lang træning er <strong>pulver eller begge</strong> ofte nemmere at bære end mange geler. Overvej at flytte noget af energien over i flasken.';
  }

  // ── Flaske-note: kun ved høj svedrate (>1000 ml/t) ──
  function fluidNote() {
    if (sweatValue() <= 1000) return '';
    return noteRow(SEI.drop, sportTerms().sweatNote);
  }

  // ── Pakkeliste-overskrift + natrium-rettesnor ──
  function packHead() {
    return '<div class="sv-result-kicker tp-pack-head">Det her pakker du</div>';
  }
  function sodiumGuideline() {
    return '<p class="tp-na-guide">Sigt efter produkter med <strong>' + sodiumBand()
      + ' mg natrium</strong> i timen.</p>';
  }

  function doseHTML(S) {
    if (!st.form) return '';
    var plan = bottlePlan();
    var bottleCount = plan.full + (plan.half ? 0.5 : 0);
    var bottleWord = (bottleCount <= 1) ? sportTerms().bottle1 : sportTerms().bottleN;

    // ── Kun pulver ──
    if (st.form === 'pulver') {
      var u = unitFor('pulver');
      if (!u) return '<p class="tp-hint">Træk slideren til din portionsstørrelse.</p>';
      var portions = Math.max(0.5, Math.round(S.carbsG / u.carbsG * 2) / 2);
      return packHead()
        + '<div class="tp-dose-tiles">'
        + doseTile(portions, u.word, doseIcon('pulver'))
        + doseTile(bottleCount, bottleWord, doseIcon('bottle'))
        + '</div>'
        + sodiumGuideline()
        + stepBlock(bottleSteps(u, S.perHour / u.carbsG))
        + fluidNote();
    }

    // ── Kun gel ──
    if (st.form === 'gel') {
      var g = unitFor('gel');
      if (!g) return '<p class="tp-hint">Træk slideren til din gelstørrelse.</p>';
      var n = gelCount(S.carbsG, g.carbsG);
      var html2 = packHead()
        + '<div class="tp-dose-tiles">'
        + doseTile(n, g.word, doseIcon('gel'))
        + doseTile(bottleCount, bottleWord, doseIcon('bottle'))
        + '</div>'
        + sodiumGuideline()
        + stepBlock(
            [stepRow(sportTerms().stepMark, flaskStepText(S.fluidMl))]
              .concat(gelStepRows(n))
          )
        + fluidNote();
      // Én rolig anbefaling ad gangen, i prioriteret rækkefølge:
      //  1) dækning — peger på den gel-størrelse der rammer målet (her får
      //     45 g mening), 2) bær-tip (færre, større geler), 3) nudge mod pulver.
      var cov = gelCoverageNote(g.carbsG, S);
      if (cov) html2 += noteRow(SEI.bulb, cov);
      else {
        var tip = gelTip(g.carbsG, S.carbsG);
        if (tip) html2 += noteRow(SEI.bulb, tip);
        else { var nudge = gelNudge(n); if (nudge) html2 += noteRow(SEI.bulb, nudge); }
      }
      return html2;
    }

    // ── Begge: pulver i flasken (1 portion pr. fuld time + ½ ved skæv
    // rest), gels dækker resten op til målet. FASE 7.11.0 — tidligere
    // brugte den "bottles" (oprundet), så pulver overfyldte og gels
    // forsvandt. Nu følger pulver bottlePlan præcist. ──
    var p2 = unitFor('pulver'), g2 = unitFor('gel');
    if (!p2 || !g2) return '<p class="tp-hint">Træk sliderne til dine størrelser.</p>';
    var planB = bottlePlan();
    var pulverPortions = planB.full + (planB.half ? 0.5 : 0);
    var pulverG = pulverPortions * p2.carbsG;
    var restG = Math.max(0, S.carbsG - pulverG);
    var gn = restG > 5 ? gelCount(restG, g2.carbsG) : 0;
    var tiles = [
      doseTile(pulverPortions, p2.word, doseIcon('pulver')),
      (gn ? doseTile(gn, g2.word, doseIcon('gel')) : ''),
      doseTile(bottleCount, bottleWord, doseIcon('bottle'))
    ];
    var rows = bottleSteps(p2, 1); // pulver-rytme: 1 portion/flaske
    if (gn) {
      rows = rows.concat(gelStepRows(gn));
    }
    return packHead()
      + '<div class="tp-dose-tiles' + (gn ? ' tp-dose-three' : '') + '">' + tiles.join('') + '</div>'
      + sodiumGuideline()
      + stepBlock(rows)
      + fluidNote();
  }
  // Flaske-rytmen som step-rækker: hver fuld time + en rest hvis skæv.
  // BEVIDST VALG (auditeret jun 2026): 40g-portioner deler ikke rent op
  // i alle mål, så pulver kan lande ±10 g/t fra lave-ende-målet. På
  // hårde pas er det den sikre side (lidt rigeligt > tørt). Ret ikke
  // dette til "præcis" — halve portioner er den praktiske granularitet.
  function bottleSteps(u, portionsPerHour) {
    portionsPerHour = Math.max(0.5, Math.round(portionsPerHour * 2) / 2);
    var gPerHour = Math.round(portionsPerHour * u.carbsG / 5) * 5;
    var plan = bottlePlan();
    var b = sportTerms().bottleLc;
    var rows = [];
    var hourMark = plan.full > 1 ? 'Hver time' : 'Time 1';
    rows.push(stepRow(hourMark, '<strong>1 ' + b + ' 500 ml</strong> med ' + portionTxt(portionsPerHour, gPerHour) + ' pulver'));
    if (plan.half) {
      var halfPortions = Math.max(0.5, Math.round(portionsPerHour / 2 * 2) / 2);
      var halfG = Math.round(halfPortions * u.carbsG / 5) * 5;
      // Resten kan være 20–49 min — nævn den faktiske rest, ikke "½ time".
      var restMark = 'Sidste ' + plan.rest + ' min';
      rows.push(stepRow(restMark, '<strong>½ ' + b + ' 250 ml</strong> med ' + portionTxt(halfPortions, halfG) + ' pulver'));
    }
    return rows;
  }
  // "1 portion (40 g)" / "½ portion (20 g)"
  function portionTxt(portions, g) {
    return fmtHalf(portions) + ' portion (' + g + ' g)';
  }

  // ── Resultatet ──
  function recalc() {
    var out = $('tp-result');
    if (!out) return;
    if (!st.minutes) { out.innerHTML = ''; updateURL(); return; }

    var S = computeSession({
      minutes: st.minutes, intensity: effIntensity(), sport: st.sport,
      sweatMlPerHour: sweatValue(), sodiumMgPerL: 700, gutTarget: st.gut
    });
    if (!S.ok) { out.innerHTML = '<div class="sv-error">' + S.error + '</div>'; return; }

    // Log det færdige pas (debounced — ikke på hver mikro-justering).
    trackResultDebounced(S);

    var isFirst = !out.querySelector('.sv-result-card');
    var intLabel = TRAINTYPE[st.trainType].label.toLowerCase();
    var head = durLabel(st.minutes)
      + ' · ' + (st.sport === 'cykel' ? 'cykel' : 'løb') + ' · ' + intLabel;

    var html = '<div class="sv-result-card' + (isFirst ? ' sv-pop' : '') + '">'
      + '<div class="sv-result-kicker">' + head + '</div>';

    if (S.waterOnly) {
      html += '<p class="sv-result-line tp-water">Vand rækker, ingen ekstra energi nødvendig.</p>'
        + noteRow(SEI.drop, sportTerms().waterNote);
    } else {
      // Switch: I alt (default) / Pr. time. FASE 7.13.0.
      html += '<div class="tp-view" role="group" aria-label="Visning">'
        + '<button type="button" class="tp-view-btn" aria-pressed="' + (st.view === 'total' ? 'true' : 'false') + '" onclick="TP.setView(\'total\')">I alt</button>'
        + '<button type="button" class="tp-view-btn" aria-pressed="' + (st.view === 'time' ? 'true' : 'false') + '" onclick="TP.setView(\'time\')">Pr. time</button>'
        + '</div>';
      // Kulhydrat/væske-fliser: bånd pr. time, eller total for passet.
      if (st.view === 'time') {
        var bandTxt = S.band.gMin === S.band.gMax ? S.band.gMin + ' g' : S.band.gMin + '–' + S.band.gMax + ' g';
        var carbLabel = S.band.optional ? 'kulhydrat / time (valgfrit)' : 'kulhydrat / time';
        html += '<div class="rk-stats tp-two">'
          + statTile(bandTxt, carbLabel)
          + statTile('500 ml', 'væske / time')
          + '</div>';
      } else {
        var totalFluid = S.fluidMl >= 1000 ? fmtHalf(Math.round(S.fluidMl / 250) / 4) + ' l' : S.fluidMl + ' ml';
        html += '<div class="rk-stats tp-two">'
          + statTile(S.carbsG + ' g', 'kulhydrat i alt')
          + statTile(totalFluid, 'væske i alt')
          + '</div>';
      }
      if (S.gutActive) {
        html += noteRow(SEI.bulb, '<strong>Mavetolerance:</strong> du træner tarmen til ' + S.perHour
          + ' g i timen, derfor ligger målet højere end passet ellers kræver. Byg op gradvist.');
      }
      if (S.optional) {
        html += '<p class="tp-optional">Valgfrit på den her varighed, vand rækker, men energien løfter kvaliteten på hårde intervaller.</p>';
      }
      html += '<div id="tp-dose"></div>';
    }
    html += logoHTML();
    html += '</div>';
    out.innerHTML = html;

    var dose = $('tp-dose');
    if (dose && !S.waterOnly) dose.innerHTML = doseHTML(S);
    updateURL();
  }

  // ── Signatur i bunden: roligt logo. Ingen shop-knap — menuen i
  // toppen er broen til shoppen, så beregneren er ren hjælp, ikke et
  // salgsværktøj. FASE 7.8.0. ──
  function logoHTML() {
    var root = document.querySelector('.tp-flow');
    var src = root ? root.getAttribute('data-logo') : '';
    if (!src) return '';
    return '<div class="tp-sig"><img src="' + esc(src) + '" alt="Sport Energy" class="tp-sig-logo"></div>';
  }

  // ── Knaphandlinger ──
  function setSport(v) {
    st.sport = v === 'cykel' ? 'cykel' : 'loeb';
    seg_track('traening_sport', { sport: st.sport });
    // Glid seg-pillen til det valgte felt (før: toolbarens initSegPills,
    // nu fjernet — vi sætter --seg-i direkte). FASE 7.18.2.
    var row = document.querySelector('.rk-radio-row.se-seg');
    if (row) row.style.setProperty('--seg-i', st.sport === 'cykel' ? 1 : 0);
    renderDurChips();   // hurtigvalg er sport-afhængige (FASE 7.23.0)
    renderDuration();   // re-markér den aktive chip i den nye række
    recalc();
  }
  // Varighed: 15 min – 6 timer, trin på 5 min. FASE 7.10.0.
  var DUR_MIN = 15, DUR_MAX = 360, DUR_STEP = 5;
  function setDur(min) {
    min = Math.round(min / DUR_STEP) * DUR_STEP;
    st.minutes = Math.max(DUR_MIN, Math.min(DUR_MAX, min));
    seg_track('traening_duration', { sport: st.sport, minutes: st.minutes });
    renderDuration();
    recalc();
  }
  function stepDur(delta) { setDur((st.minutes || 60) + delta); }
  function durDisplay(min) {
    var h = Math.floor(min / 60), m = min % 60;
    if (h === 0) return m + ' min';
    if (m === 0) return h + ' t';
    return h + ' t ' + m + ' min';
  }
  function renderDuration() {
    var el = document.getElementById('tp-dur-num');
    if (el) el.textContent = durDisplay(st.minutes);
    // Marker hurtigvalg-chip hvis den matcher præcist.
    var chips = document.querySelectorAll('#tp-duration ~ .tp-dur-quick .tp-dur-chip, .tp-dur-quick .tp-dur-chip');
    for (var i = 0; i < chips.length; i++) {
      var oc = chips[i].getAttribute('onclick') || '';
      var mm = oc.match(/setDur\((\d+)\)/);
      chips[i].setAttribute('aria-pressed', mm && parseInt(mm[1], 10) === st.minutes ? 'true' : 'false');
    }
  }
  function setTrainType(k) { if (TRAINTYPE[k]) st.trainType = k; seg_track('traening_traintype', { traintype: st.trainType, intensity: effIntensity() }); renderIntensity(); renderCoverage(); recalc(); }
  function setStomach(v) { st.stomach = v === 'tom' ? 'tom' : 'fyldt'; seg_track('traening_personal_setting', { setting: 'stomach', value: st.stomach }); renderNumbers(); recalc(); }
  function setGut(v) { st.gut = (v === '90') ? 90 : (v === '120') ? 120 : null; seg_track('traening_personal_setting', { setting: 'gut', value: st.gut || 'off' }); renderNumbers(); recalc(); }
  // Svedrate-pillen glider uden fuld renderNumbers (svedraten påvirker ikke
  // de andre rækker). Lav=0, Normal=1, Høj=2. FASE 7.21.3.
  function setSweat(v) {
    var row = document.querySelector('.rk-radio-row.se-seg input[name="tp-sweat"]');
    row = row ? row.closest('.rk-radio-row.se-seg') : null;
    if (row) row.style.setProperty('--seg-i', v === '600' ? 0 : v === '1300' ? 2 : 1);
    seg_track('traening_personal_setting', { setting: 'sweat', value: v });
    recalc();
  }
  function setForm(v) { st.form = (st.form === v ? null : v); seg_track('traening_form', { form: st.form || 'none' }); renderCoverage(); recalc(); }
  function snap(kind, i) { st.customG[kind] = SNAP[kind].steps[i]; renderCoverage(); recalc(); }
  function setView(v) { st.view = v === 'time' ? 'time' : 'total'; recalc(); }
  function togglePlan() {
    st.planOpen = !st.planOpen;
    if (st.planOpen) seg_track('traening_plan_expanded', trackContext());
    var box = document.querySelector('.tp-steps');
    if (box) {
      box.classList.toggle('is-open', st.planOpen);
      var btn = box.querySelector('.tp-steps-toggle');
      if (btn) btn.setAttribute('aria-expanded', st.planOpen ? 'true' : 'false');
    }
  }
  function slide(kind, i) {
    var v = SNAP[kind].steps[parseInt(i, 10)];
    if (v == null) return;
    st.customG[kind] = v;
    // Live-opdatér label + ticks uden fuld recalc (glat under træk).
    var block = document.querySelector('.tp-picker[data-kind="' + kind + '"] .tp-slider');
    if (block) {
      var val = block.querySelector('.tp-slider-val');
      if (val) val.textContent = v + ' g kulhydrat pr. ' + (kind === 'pulver' ? 'portion' : 'gel');
      var ticks = block.querySelectorAll('.tp-tick');
      for (var t = 0; t < ticks.length; t++) ticks[t].classList.toggle('is-on', SNAP[kind].steps[t] === v);
      // Skjul anbefalingslinjen live når man rammer (eller passerer til) det anbefalede.
      var recBtn = block.querySelector('.tp-rec');
      if (recBtn) recBtn.style.display = (recommendedSize(kind) === v) ? 'none' : '';
    }
    var dose = $('tp-dose');
    if (dose) {
      var S = computeSession({ minutes: st.minutes, intensity: effIntensity(), sport: st.sport, sweatMlPerHour: sweatValue(), sodiumMgPerL: 700, gutTarget: st.gut });
      if (S.ok) dose.innerHTML = doseHTML(S);
    }
    updateURL();
  }
  function toggleNumbers() { st.numbersOpen = !st.numbersOpen; renderNumbers(); }

  // ── URL-tilstand (stille — et bogmærke husker dit standardpas) ──
  function updateURL() {
    try {
      var p = new URLSearchParams();
      if (st.minutes) {
        p.set('d', st.minutes); p.set('sp', st.sport); p.set('t', st.trainType);
        if (st.form) p.set('f', st.form);
      }
      var q = p.toString();
      history.replaceState(null, '', window.location.pathname + (q ? '?' + q : ''));
    } catch (e) {}
  }
  function loadURL() {
    try {
      var p = new URLSearchParams(window.location.search);
      if (p.has('sp')) st.sport = p.get('sp') === 'cykel' ? 'cykel' : 'loeb';
      if (p.has('t')) { var tv = p.get('t'); if (TRAINTYPE[tv]) st.trainType = tv; }
      if (p.has('f')) { var fv = p.get('f'); if (fv === 'pulver' || fv === 'gel' || fv === 'begge') st.form = fv; }
      if (p.has('d')) {
        var d = parseInt(p.get('d'), 10);
        if (!isNaN(d)) {
          d = Math.round(d / 5) * 5;
          if (d >= 15 && d <= 360) { st.minutes = d; return true; }
        }
      }
      return false;
    } catch (e) { return false; }
  }
  function syncControls() {
    var r = document.querySelector('input[name="tp-sport"][value="' + st.sport + '"]'); if (r) r.checked = true;
    var row = document.querySelector('.rk-radio-row.se-seg');
    if (row) row.style.setProperty('--seg-i', st.sport === 'cykel' ? 1 : 0);
    renderDurChips();
    renderDuration();
  }

  // ── App- vs. browser-tilstand: skjul webshop-chrome i standalone ──
  function isStandalone() {
    return (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches)
      || window.navigator.standalone === true;
  }
  // Grov enheds-skelnen til showcase vs. install-knap. Vi bruger både
  // pegeredskab (coarse = touch) og bredde, så en stor tablet ikke
  // fejlagtigt får desktop-showcasen. FASE 7.17.0.
  function isMobileDevice() {
    var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    var narrow = window.matchMedia && window.matchMedia('(max-width: 820px)').matches;
    var ua = /iphone|ipad|ipod|android/i.test(navigator.userAgent);
    return narrow || (coarse && ua);
  }
  function applyDisplayMode() {
    var html = document.documentElement;
    if (isStandalone()) { html.classList.add('tp-app'); hideShopifyChrome(); }  // installeret app
    html.classList.add(isMobileDevice() ? 'tp-mobile' : 'tp-desktop');
  }

  // I standalone er dette en APP, ikke en webshop-side — så Shopify-temaets
  // header, annoncerings-banner og footer skal væk. Det er sværere end det
  // lyder, fordi Ella/Halo pakker ALT (header-gruppe + main + footer) ind i
  // en fælles <div class="body-content-wrapper">. Et naivt "skjul body's
  // børn før main" rammer derfor ikke — wrapper'en ER body's eneste barn.
  //
  // To strategier, så vi er robuste på tværs af temaer (FASE 7.27.1):
  //  1) Direkte: skjul Shopify's standard sektion-gruppe-wrappere
  //     (.shopify-section-group-header-group / -footer-group) — dem bruger
  //     Ella faktisk. Plus et par almindelige header/banner-klasser.
  //  2) Generisk: gå OP fra #MainContent til det punkt hvor forælderen har
  //     flere element-børn (forgreningen), og skjul de søskende der IKKE
  //     indeholder beregneren. Fanger temaer uden gruppe-klasserne.
  function hideShopifyChrome() {
    try {
      var root = document.querySelector('.tp-flow');
      var main = document.getElementById('MainContent') || document.querySelector('main');
      if (!main) return;

      var hide = function (el) {
        if (el && !(root && el.contains(root)) && el !== main && !main.contains(el)) {
          el.style.setProperty('display', 'none', 'important');
        }
      };
      var elementChildCount = function (el) {
        return el.children ? el.children.length : 0;
      };
      var sweep = function (parent, keep) {
        var kids = parent.children;
        for (var i = 0; i < kids.length; i++) {
          var k = kids[i];
          if (k === keep || (root && k.contains(root)) || k.contains(main)) continue;
          if (k.tagName === 'SCRIPT' || k.tagName === 'STYLE' || k.tagName === 'LINK' || k.tagName === 'NOSCRIPT' || k.tagName === 'TEMPLATE') continue;
          k.style.setProperty('display', 'none', 'important');
        }
      };

      // 1) Direkte klasse-mål — Ella/Halo's header- og footer-grupper m.fl.
      var selectors = [
        '.shopify-section-group-header-group',
        '.shopify-section-group-footer-group',
        '.announcement-bar',
        'header.header',
        '.header-advanced',
        '#shopify-section-header'
      ];
      for (var s = 0; s < selectors.length; s++) {
        var nodes = document.querySelectorAll(selectors[s]);
        for (var n = 0; n < nodes.length; n++) hide(nodes[n]);
      }

      // 2) Generisk søskende-fejning på forgrenings-niveauet. Gå op fra main
      //    indtil forælderen har mere end ét element-barn — der ligger
      //    header/footer som søskende til main-grenen.
      var node = main;
      while (node.parentElement) {
        var p = node.parentElement;
        if (p.tagName === 'BODY') { sweep(p, node); break; }
        if (elementChildCount(p) > 1) { sweep(p, node); }
        node = p;
      }

      // 3) Tema lægger ofte top-padding/margin for sticky header — nulstil.
      main.style.setProperty('padding-top', '0', 'important');
      main.style.setProperty('margin-top', '0', 'important');
    } catch (e) {}
  }

  // App-knappen på desktop kan ikke installere til en telefon — den
  // fører til QR-koden, som ER vejen til at få den på mobilen. FASE 7.19.0.
  function scrollToQR() {
    var qr = document.querySelector('.tp-qr');
    if (!qr) return;
    seg_track('traening_qr', {});
    qr.scrollIntoView({ behavior: 'smooth', block: 'center' });
    qr.classList.add('is-flash');
    setTimeout(function () { qr.classList.remove('is-flash'); }, 1400);
  }

  // ── Desktop-showcase: klik på en USP skifter telefon-billedet, plus
  // en QR-kode der peger på siden (scan → åbn på mobil). FASE 7.17.0.
  // Hele sektionen er skjult på mobil og i app-tilstand via CSS, så vi
  // springer setup over der for at spare arbejde.
  function initShowcase() {
    var html = document.documentElement;
    if (html.classList.contains('tp-mobile') || html.classList.contains('tp-app')) return;
    var usps = document.querySelectorAll('.tp-usp');
    var img = $('tp-phone-img');
    for (var i = 0; i < usps.length; i++) {
      usps[i].addEventListener('click', function () {
        for (var j = 0; j < usps.length; j++) usps[j].classList.remove('is-active');
        this.classList.add('is-active');
        var src = this.getAttribute('data-img');
        if (img && src) {
          img.classList.add('is-swapping');
          setTimeout(function () { img.src = src; img.classList.remove('is-swapping'); }, 140);
        }
      });
    }
    // Hvis billedet ikke kan loades, skjul det rent (ingen placeholder-tekst).
    if (img) {
      img.addEventListener('error', function () { img.style.visibility = 'hidden'; });
    }
    drawQR();
  }

  // Letvægts-QR uden eksternt bibliotek: vi bruger et offentligt QR-
  // billed-endpoint som img-kilde. Peger på sidens egen URL, så scan
  // åbner præcis denne side på mobilen. FASE 7.17.0.
  function drawQR() {
    var box = $('tp-qr-code');
    if (!box) return;
    var url = window.location.origin + window.location.pathname;
    var qimg = document.createElement('img');
    qimg.alt = 'QR-kode til træningsberegneren';
    qimg.width = 96; qimg.height = 96;
    qimg.src = 'https://api.qrserver.com/v1/create-qr-code/?size=96x96&margin=0&data=' + encodeURIComponent(url);
    box.appendChild(qimg);
  }

  // ── PWA: ikon på hjemskærmen + install-knap ────────
  function initPWA() {
    var root = document.querySelector('.tp-flow');
    if (!root) return;
    var i180 = root.getAttribute('data-icon-180') || '';
    var i192 = root.getAttribute('data-icon-192') || '';
    var i512 = root.getAttribute('data-icon-512') || '';

    function headTag(name, attrs) {
      var el = document.createElement(name);
      for (var k in attrs) el.setAttribute(k, attrs[k]);
      document.head.appendChild(el);
    }
    headTag('meta', { name: 'apple-mobile-web-app-capable', content: 'yes' });
    headTag('meta', { name: 'mobile-web-app-capable', content: 'yes' });
    headTag('meta', { name: 'apple-mobile-web-app-status-bar-style', content: 'black-translucent' });
    headTag('meta', { name: 'apple-mobile-web-app-title', content: 'Energiplan' });
    headTag('meta', { name: 'theme-color', content: '#0a2420' });
    if (i180) headTag('link', { rel: 'apple-touch-icon', href: i180 });

    try {
      var man = {
        name: 'Sport Energy · Energiplan', short_name: 'Energiplan',
        start_url: window.location.origin + window.location.pathname,
        scope: window.location.pathname, display: 'standalone',
        background_color: '#ffffff', theme_color: '#0a2420', icons: []
      };
      if (i192) man.icons.push({ src: i192, sizes: '192x192', type: 'image/png' });
      if (i512) man.icons.push({ src: i512, sizes: '512x512', type: 'image/png', purpose: 'any maskable' });
      var blob = new Blob([JSON.stringify(man)], { type: 'application/manifest+json' });
      headTag('link', { rel: 'manifest', href: URL.createObjectURL(blob) });
    } catch (e) {}

    var card = $('tp-install');
    if (!card) return;
    if (isStandalone()) { card.remove(); return; }
    // FASE 7.21.0: kortet har nu en fast logo-bjælke i markupen; vi skriver
    // kun install-teksten ind i #tp-install-body, ikke hele kortet.
    var body = $('tp-install-body') || card;

    var deferred = null;
    window.addEventListener('beforeinstallprompt', function (e) {
      e.preventDefault(); deferred = e;
      body.innerHTML = '<span class="tp-install-txt">Læg beregneren på hjemskærmen, så er den ét tryk væk, hver gang du skal træne.</span>'
        + '<button type="button" class="tp-install-btn" id="tp-install-btn">'
        + '<span class="tp-install-ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v12M7 10l5 5 5-5M5 21h14"/></svg></span>Læg på hjemskærmen</button>';
      card.hidden = false;
      var btn = $('tp-install-btn');
      if (btn) btn.addEventListener('click', function () {
        if (!deferred) return;
        seg_track('traening_install', { step: 'prompt' });
        deferred.prompt();
        deferred.userChoice.then(function (choice) {
          seg_track('traening_install', { step: 'choice', outcome: (choice && choice.outcome) || 'unknown' });
          deferred = null; card.remove();
        });
      });
    });

    if (/iphone|ipad|ipod/i.test(navigator.userAgent)) {
      body.innerHTML = '<span class="tp-install-txt">Læg beregneren på hjemskærmen: tryk <strong>Del</strong> i Safari og vælg <strong>Føj til hjemmeskærm</strong>. Så ligger den klar som en app.</span>';
      card.hidden = false;
    }
  }

  window.TP = {
    setSport: setSport, setDur: setDur, stepDur: stepDur,
    setTrainType: setTrainType,
    setStomach: setStomach, setGut: setGut, setSweat: setSweat,
    setForm: setForm, snap: snap, slide: slide,
    setView: setView, togglePlan: togglePlan,
    toggleNumbers: toggleNumbers, recalc: recalc, scrollToQR: scrollToQR
  };

  applyDisplayMode();
  loadURL();
  renderIntensity();
  renderCoverage();
  renderNumbers();
  syncControls();
  initPWA();
  initShowcase();
  recalc();

  // Page-view: ét event når beregneren er klar, med enheds-tilstand og
  // den (evt. URL-gendannede) udgangs-kontekst. FASE 7.25.0.
  (function () {
    var html = document.documentElement;
    var mode = html.classList.contains('tp-app') ? 'app'
      : html.classList.contains('tp-mobile') ? 'mobil' : 'desktop';
    var ctx = trackContext();
    ctx.mode = mode;
    seg_track('traening_opened', ctx);
  })();
})();